import type { Catalog } from "./en";

export const ja: Catalog = {
  "common.retry": "再試行",
  "common.reload": "再読み込み",
  "common.save": "保存",
  "common.saving": "保存中…",
  "common.saved": "保存しました",
  "common.saveFailed": "保存できませんでした",
  "common.saveChanges": "変更を保存",
  "common.delete": "削除",
  "common.remove": "削除",
  "common.cancel": "キャンセル",
  "common.edit": "編集",
  "common.openLink": "開く",
  "common.back": "← 戻る",
  "common.loading": "読み込み中",
  "common.loadingMore": "読み込み中…",
  "common.sending": "送信中…",
  "common.error": "問題が発生しました",
  "common.failed": "失敗しました",
  "common.name": "名前",
  "common.email": "メールアドレス",
  "common.title": "タイトル",
  "common.language": "言語",

  "time.now": "たった今",
  "time.lessThanMinute": "1分未満",
  "time.minutes": "{n}分",
  "time.hours": "{n}時間",
  "time.days": "{n}日",

  "nav.inbox": "受信トレイ",
  "nav.faq": "ヘルプセンター",
  "nav.reports": "レポート",
  "nav.settings": "設定",
  "layout.workspace": "ワークスペース",
  "layout.newWorkspace": "+ 新しいワークスペース",
  "layout.signOut": "ログアウト",

  "app.unreachable.title": "サーバーに接続できません",
  "app.unreachable.body": "接続を確認して、もう一度お試しください。",
  "app.noWorkspaces.title": "ワークスペースがまだありません",
  "app.noWorkspaces.body": "管理者にワークスペースへの招待を依頼してください。",

  "error.pane": "この会話を表示できませんでした。",
  "error.tryAgain": "もう一度試す",
  "error.body": "この画面で予期しないエラーが発生しました。",
  "error.goInbox": "受信トレイへ",

  "login.title": "サポートにログイン",
  "login.sent": "{email} にアクセス権がある場合、ログインリンクを送信しました。リンクの有効期限は15分です。",
  "login.intro": "1回限り有効なログインリンクをメールでお送りします。",
  "login.email": "仕事用メールアドレス",
  "login.sendFailed": "リンクを送信できませんでした。1分後にもう一度お試しください。",
  "login.submit": "リンクをメールで受け取る",
  "verify.incomplete": "このリンクは不完全です。",
  "verify.failed": "ログインできませんでした。",
  "verify.expired": "リンクの有効期限が切れています",
  "verify.signingIn": "ログインしています…",
  "verify.newLink": "新しいリンクをリクエスト",

  "newWs.superAdminOnly": "ワークスペースを作成できるのはスーパー管理者のみです。",
  "newWs.created": "ワークスペースを作成しました",
  "newWs.copySecret": "今すぐIDシークレットをコピーしてください。表示されるのは一度だけです（後で再生成できます）。",
  "newWs.secretLabel": "IDシークレット（サーバー専用）",
  "newWs.continue": "セットアップへ進む",
  "newWs.createFailed": "ワークスペースを作成できませんでした",
  "newWs.title": "新しいワークスペース",
  "newWs.intro": "アプリまたはプロダクトごとに1つのワークスペース。それぞれに専用のヘルプセンター、受信トレイ、キーがあります。",
  "newWs.submit": "ワークスペースを作成",

  "reports.period": "期間",
  "reports.lastDays": "過去{count}日間",
  "reports.loadFailed": "レポートを読み込めませんでした。",
  "reports.conversations": "会話",
  "reports.resolved": "解決済み",
  "reports.medianReply": "初回返信時間（中央値）",
  "reports.satisfaction": "満足度",
  "reports.ratingsCount": "{count}件の評価",
  "reports.ratingsCount.one": "{count}件の評価",
  "reports.ratingsCount.other": "{count}件の評価",
  "reports.ratings": "評価",
  "reports.barLabel": "評価{score}：{count}件",
  "reports.barLabel.one": "評価{score}：{count}件",
  "reports.barLabel.other": "評価{score}：{count}件",
  "reports.recentComments": "最近のコメント",
  "reports.noComments": "コメントはまだありません。",

  "status.open": "対応中",
  "status.pending": "保留中",
  "status.resolved": "解決済み",

  "inbox.title": "サポート受信トレイ",
  "inbox.conversations": "会話",
  "inbox.liveStopped": "リアルタイム更新が停止しました。",
  "inbox.notifyPrompt": "新しいメッセージをデスクトップ通知で受け取りましょう。",
  "inbox.enableNotifications": "通知を有効にする",
  "inbox.notNow": "後で",
  "inbox.statusFilter": "ステータス",
  "inbox.assignee": "担当者",
  "inbox.all": "すべて",
  "inbox.mine": "自分",
  "inbox.unassigned": "未割り当て",
  "inbox.loadFailed": "会話を読み込めませんでした。",
  "inbox.empty.open": "対応中の会話はありません 🎉",
  "inbox.empty.pending": "保留中の会話はありません 🎉",
  "inbox.empty.resolved": "解決済みの会話はありません 🎉",
  "inbox.you": "あなた",
  "inbox.agent": "担当者",
  "inbox.attachment": "📎 添付ファイル",
  "inbox.unreadCount": "未読{count}件",
  "inbox.loadMoreFailed": "これ以上の会話を読み込めませんでした",
  "inbox.loadMore": "さらに読み込む",
  "inbox.select": "会話を選択してください",
  "inbox.visitor": "訪問者 {id}",

  "contact.aria": "連絡先",
  "contact.verified": "✓ 認証済みユーザー",
  "contact.anonymous": "匿名の訪問者",
  "contact.userId": "ユーザーID",
  "contact.lastSeen": "最終アクセス",
  "contact.started": "開始日時",
  "contact.rating": "評価",

  "event.resolved": "解決済み",
  "event.reopened": "再開",
  "event.assigned": "割り当て",
  "event.csat_request": "評価をリクエスト",
  "event.auto_reply": "自動返信",

  "sys.resolved": "解決済みにしました",
  "sys.reopened": "再開しました",
  "sys.assigned": "{name} に割り当てました",
  "sys.csat_request": "評価をリクエストしました",
  "sys.auto_reply": "自動返信：{body}",

  "thread.aria": "会話",
  "thread.verified": "認証済みユーザー",
  "thread.you": "{name}（あなた）",
  "thread.reopen": "再開",
  "thread.snooze": "保留にする",
  "thread.snoozeTitle": "お客様の返信待ち",
  "thread.resolve": "解決",
  "thread.liveStopped": "この会話のリアルタイム更新が停止しました。",
  "thread.loadFailed": "この会話を読み込めませんでした。",
  "thread.loadEarlier": "以前のメッセージを読み込む",
  "thread.loadEarlierFailed": "以前のメッセージを読み込めませんでした",
  "thread.failedRetry": "送信失敗：再試行",
  "thread.typing": "{name} が入力中…",
  "thread.seen": "既読",
  "thread.updateFailed": "更新できませんでした",

  "composer.uploadFailed": "アップロードできませんでした",
  "composer.savedReplies": "定型返信",
  "composer.placeholder": "{name} に返信…（/ で定型返信）",
  "composer.reply": "返信",
  "composer.attach": "📎 添付",
  "composer.uploading": "アップロード中…",
  "composer.removeFile": "{name} を削除",
  "composer.send": "送信",

  "faq.untitled": "（無題）",
  "faq.loadFailed": "ヘルプセンターを読み込めませんでした。",
  "faq.loadFailedToast": "ヘルプセンターを読み込めませんでした",
  "faq.notFound": "記事が見つかりません。",
  "faq.backToList": "ヘルプセンターに戻る",
  "faq.intro": "記事はアプリ内のヘルプセンターに表示され、お客様がチャットを始める前に提案されます。",
  "faq.newArticle": "新しい記事",
  "faq.categories": "カテゴリ",
  "faq.categoriesIntro": "記事をトピックごとにまとめます。タイトルは言語ごとに設定します。",
  "faq.addCategoryFailed": "カテゴリを追加できませんでした",
  "faq.newCategoryPlaceholder": "新しいカテゴリのタイトル（{locale}）",
  "faq.addCategory": "カテゴリを追加",
  "faq.noArticles": "記事はまだありません。よくある質問から始めましょう。",
  "faq.uncategorized": "未分類",
  "faq.languages": "言語",
  "faq.views": "閲覧数",
  "faq.helpful": "役に立った",
  "faq.helpfulValue": "{votes}件中{percent}%",
  "faq.published": "公開中",
  "faq.draft": "下書き",
  "faq.missing": "未作成",
  "faq.categoryTitle": "タイトル（{locale}）",
  "faq.saveCategoryFailed": "カテゴリを保存できませんでした",
  "faq.categorySaved": "カテゴリを保存しました",
  "faq.deleteCategoryConfirm": "このカテゴリを削除しますか？所属する記事は未分類になります。",
  "faq.deleteCategoryFailed": "カテゴリを削除できませんでした",
  "faq.addTitleFirst": "先にタイトルを入力してください",
  "faq.deleteArticleConfirm": "この記事をすべての言語で削除しますか？",
  "faq.deleteArticleFailed": "記事を削除できませんでした",
  "faq.category": "カテゴリ",
  "faq.titlePlaceholder": "〜するには？",
  "faq.untitledExisting": "{locale} のタイトルを入力するか、下の {locale} の翻訳を削除してください。",
  "faq.untitledNew": "{locale} のタイトルを入力するか、本文を空にしてこの言語を除外してください。",
  "faq.slug": "URLスラッグ",
  "faq.slugHint": "空欄の場合はタイトルから自動生成されます。",
  "faq.body": "本文（Markdown）",
  "faq.bodyHint": "**太字**、*斜体*、リスト、リンク、画像、`コード` に対応しています。HTMLはテキストとして表示されます。",
  "faq.publishedIn": "{locale} で公開",
  "faq.removeTranslation": "{locale} の翻訳を削除",
  "faq.preview": "プレビュー",
  "faq.untitledPreview": "無題",

  "settings.tab.general": "一般",
  "settings.tab.hours": "営業時間",
  "settings.tab.install": "インストール",
  "settings.tab.push": "プッシュ通知",
  "settings.tab.team": "チーム",
  "settings.tab.canned": "定型返信",
  "settings.adminOnly": "これらの設定を変更できるのはワークスペース管理者のみです。",
  "settings.loadFailed": "設定を読み込めませんでした。",
  "settings.reloadFailed": "設定を再読み込みできませんでした",

  "general.branding": "ブランディング",
  "general.brandingIntro": "アプリ内でのヘルプセンターとチャットの見た目です。",
  "general.brandColor": "ブランドカラー",
  "general.brandColorPicker": "ブランドカラーを選択",
  "general.brandColorHex": "ブランドカラー（16進数）",
  "general.logoUrl": "ロゴURL",
  "general.logoHint": "ヘルプセンター上部に表示されるHTTPS画像です。",
  "general.languages": "言語",
  "general.languagesIntro": "ここで有効にした言語では、画面表示が端末の言語に合わせて切り替わります。記事はデフォルト言語にフォールバックします。",
  "general.defaultLanguage": "デフォルト言語",
  "general.greeting": "あいさつ（{locale}）",
  "general.greetingHint": "空欄の場合は組み込みのあいさつを使用します。",
  "general.csatTitle": "満足度評価",
  "general.csatAsk": "会話の解決時にお客様に評価を依頼する",

  "hours.intro": "営業時間外は、お客様に不在であることが表示され、自動返信が送られます。",
  "hours.enable": "営業時間を使用する（使用しない場合は常にオンラインと表示されます）",
  "hours.timezone": "タイムゾーン",
  "hours.open": "営業",
  "hours.closed": "休業",
  "hours.opens": "{day}の開始時刻",
  "hours.closes": "{day}の終了時刻",
  "hours.replyTitle": "返信時間と自動返信",
  "hours.typical": "通常の返信時間（分）",
  "hours.typicalHint": "オンライン中にお客様に表示されます。空欄にすると非表示になります。",
  "hours.away": "不在メッセージ（{locale}）",
  "hours.awayHint": "営業時間外にメッセージが届くと自動で送信されます（1つの会話につき12時間に1回まで）。",

  "install.keys": "キー",
  "install.publishableKey": "公開キー",
  "install.publishableHint": "アプリやウェブサイトに含めても安全です。",
  "install.identitySecret": "IDシークレット",
  "install.secretHint": "サーバー上で保管してください。ユーザーIDに署名し、チャットをログイン中のユーザーに紐づけるために使います。",
  "install.secretHidden": "非表示。再生成すると、既存のユーザーハッシュはすぐに無効になります。",
  "install.rotateConfirm": "IDシークレットを再生成しますか？サーバーはすぐに新しいシークレットに切り替える必要があります。",
  "install.rotateFailed": "シークレットを再生成できませんでした",
  "install.rotate": "シークレットを再生成",
  "install.origins": "許可するウェブサイト",
  "install.originsIntro": "ウェブウィジェットの利用を許可するオリジン（1行に1つ、例：https://app.example.com）。* ですべて許可します。モバイルアプリでは不要です。",
  "install.saveOrigins": "オリジンを保存",
  "install.reactWeb": "React（ウェブ）",
  "install.anyWebsite": "任意のウェブサイト",
  "install.verifyUsers": "ユーザーの認証（サーバー側）",
  "install.verifyIntro": "サーバーでユーザーハッシュを計算し、ユーザーIDと一緒に渡してください。",

  "push.fcmTitle": "Android（Firebase Cloud Messaging）",
  "push.fcmIntro": "Cloud Messaging の権限を持つ Firebase サービスアカウントの JSON をアップロードしてください。",
  "push.fcmFile": "Firebase サービスアカウントの JSON",
  "push.saveFcm": "FCM の認証情報を保存",
  "push.apnsTitle": "iOS（Apple Push Notification service）",
  "push.apnsIntro": "Apple Developer アカウントで APNs 認証キー（.p8）を作成してください。",
  "push.p8File": ".p8 キーファイル",
  "push.keyId": "キーID",
  "push.teamId": "チームID",
  "push.saveApns": "APNs の認証情報を保存",
  "push.configured": "設定済み（{date}）",
  "push.notConfigured": "未設定",

  "team.invite": "チームメンバーを招待",
  "team.inviteIntro": "ログインリンク付きのメールが届きます。",
  "team.role": "役割",
  "team.role.agent": "担当者",
  "team.role.admin": "管理者",
  "team.sendInvite": "招待を送信",
  "team.inviteSent": "招待を送信しました",
  "team.inviteNoEmail": "追加しました。メールは送信していません：このアドレスには最近ログインメールが複数届いています。そのいずれかを使えます。",
  "team.inviteFailed": "招待できませんでした",
  "team.members": "メンバー",
  "team.loadFailed": "メンバーを読み込めませんでした。",
  "team.loadFailedToast": "メンバーを読み込めませんでした",
  "team.online": "オンライン",
  "team.removeConfirm": "{name} を削除しますか？担当している会話は未割り当てになります。",
  "team.removeFailed": "メンバーを削除できませんでした",

  "canned.intro": "返信欄に {shortcut} と入力すると挿入できます。{name} はお客様の名前、{agent} はあなたの名前に置き換わります。",
  "canned.shortcut": "ショートカット",
  "canned.shortcutHint": "小文字、数字、ハイフン",
  "canned.message": "メッセージ",
  "canned.empty": "定型返信はまだありません。作成したら、返信欄で /ショートカット を入力して挿入できます。",
  "canned.new": "新しい定型返信",
  "canned.deleteConfirm": "定型返信 /{shortcut} を削除しますか？",
  "canned.deleteFailed": "定型返信を削除できませんでした",
  "canned.loadFailed": "定型返信を読み込めませんでした。",
  "canned.loadFailedToast": "定型返信を読み込めませんでした",
};
